import { Col, Row } from 'antd';
import { useContext } from 'react';
import { LibraryContext } from './context-provider';
import styles from './styles.module.css';

export default function FolderColorPalette() {
   const { renameFile, selectedLibrary, library } = useContext(LibraryContext);

   async function handleColorSelect(e, color) {
      // e.stopPropagation();
      e.preventDefault();
      const selected = selectedLibrary[0];

      if (selected.type === 'folder') {
         // await renameFolder(selected._id, values.name);
         library.updateFolder(selected._id, { color: color });
      }
   }

   const colors = [
      '#ff4d4f',
      '#ff7a45',
      '#ffa940',
      '#ffc53d',
      '#73d13d',
      '#36cfc9',
      '#40a9ff',
      '#597ef7',
      '#9254de',
      '#f759ab',
   ];

   return (
      <>
         <Row gutter={[8, 8]} style={{ width: '100%', maxWidth: '170px' }}>
            {colors.map((color, index) => (
               <Col key={index} onClick={(e) => handleColorSelect(e, color)}>
                  <ColorPaletteItem color={color} />
               </Col>
            ))}
         </Row>
      </>
   );
}

function ColorPaletteItem({ color }) {
   return (
      <div
         className={styles.folderColorSelectButton}
         style={{
            backgroundColor: color,
         }}
      />
   );
}
